// @flow

import type {
  Article,
  Navigation,
  NavigationLink,
  NavigationProduct,
} from 'docs/data';

// This performs a traversal over a NavigationProduct to return a flat list of the
// active links.
export const getProductBreadcrumbs = (
  activeProduct: NavigationProduct,
): Array<NavigationProduct | NavigationLink> => {
  const stack: Array<Array<NavigationProduct | NavigationLink>> = [
    [activeProduct],
  ];
  while (stack.length > 0) {
    const breadcrumbs = stack.pop();
    const curr = breadcrumbs[breadcrumbs.length - 1];
    if (curr.selected) {
      return breadcrumbs;
    }
    if (Array.isArray(curr.children)) {
      curr.children.forEach((child: any) =>
        stack.push([...breadcrumbs, child]),
      );
    }
  }
  return [];
};

// Given a navigation object return the breadcrumbs which are displayed in the search results
export const getSearchResultBreadcrumbs = (
  navigation: Navigation,
  article: Article,
) => {
  const activeProduct = navigation.products.find((p) => p.active);
  let crumbs: Array<string> = [];

  // HACK(matv): The integration builder is not in the navigation structure, so
  // we special case it in.
  if (article.path.includes('/integration-builder')) {
    crumbs = ['Integration Builder'];
    const parts = article.path.split('/');
    const product = parts[parts.length - 2];
    if (product) {
      const formattedProduct = product[0].toUpperCase() + product.substring(1);
      crumbs.unshift(formattedProduct);
    }
    return crumbs;
  }

  if (activeProduct) {
    crumbs = getProductBreadcrumbs(activeProduct).map((crumb) => crumb.text);
  } else {
    const activeTopic = navigation.topics.find((t) => t.active);
    if (activeTopic) {
      crumbs = [activeTopic.text];
    }
  }
  if (crumbs.length === 0) {
    // If we cannot find any crumbs, set them to be Home > Section title
    crumbs = ['Home', article.metadata.title];
  } else if (crumbs.length === 1) {
    // Having only 1 breadcrumb will look bad in results, so add "Home"
    crumbs.unshift('Home');
  }

  return crumbs;
};
